import React from "react";
import { NewHomeContainer } from "../../containers";
import { withAppLayout, withNewLayout } from "../../hoc";

const Home = (props) => {
  return <NewHomeContainer {...props} />;
};

export default withNewLayout(Home);
